import Skeleton from '@mui/material/Skeleton'; 
import './index.scss';

// Reusable component for the product skeleton
const ProductSkeleton = () => {
  return (
    <div className="productInfo-skeleton">
      <Skeleton
        animation="wave"
        variant="rectangular"
        className="product-info-img"
      />
      <div className='product-details-skeleton'>
      <Skeleton
        animation="wave"
        variant="rectangular"
        className='order-summary-product-name'
      />
      <Skeleton
        animation="wave"
        variant="rectangular"
        className='order-summary-product-details'
      />
      </div>
    </div>
  );
};

// Component to render the list of product skeletons
const CartProductSkeletons = () => {
  return (
    <div className="cart-products">
      <ProductSkeleton />
      <ProductSkeleton />
      <ProductSkeleton />
    </div>
  );
};

export default CartProductSkeletons;
